var _style, _g, _g2, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPe26Ys778488(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3375.9 708.7",
    style: {
      enableBackground: "new 0 0 3375.9 708.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.ctm_st0{fill:#FFFFFF;}\n\t.ctm_st1{fill:url(#CTM_SVGID_1_);}\n\t.ctm_st2{fill:url(#CTM_SVGID_2_);}\n\t.ctm_st3{opacity:0.55;fill:url(#CTM_SVGID_3_);}\n\t.ctm_st4{fill:url(#CTM_SVGID_4_);}\n\t.ctm_st5{fill:url(#CTM_SVGID_5_);}\n\t.ctm_st6{fill:url(#CTM_SVGID_6_);}\n\t.ctm_st7{fill:url(#CTM_SVGID_7_);}\n\t.ctm_st8{fill:url(#CTM_SVGID_8_);}\n\t.ctm_st9{fill:url(#CTM_SVGID_9_);}\n\t.ctm_st10{opacity:0.71;fill:url(#CTM_SVGID_10_);}\n\t.ctm_st11{opacity:0.83;fill:url(#CTM_SVGID_11_);}\n\t.ctm_st12{fill:url(#CTM_SVGID_12_);}\n\t.ctm_st13{fill:url(#CTM_SVGID_13_);}\n\t.ctm_st14{opacity:0.8;fill:url(#CTM_SVGID_14_);}\n\t.ctm_st15{fill:url(#CTM_SVGID_15_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M792.2,200.2h-9.3l-17.2-57l-2.4-9.5H763l-2.3,9.7l-15.1,56.8h-10.1l-24.6-79.4h10.3l16.1,53.3l3.9,14.2h0.2 l2.7-11.4l15-56h9.3l17.5,57.6l2.7,9.7h0.2c7.4-21.6,13.8-44.6,17.7-67.3h9.8C811.5,144.2,803.6,171.9,792.2,200.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M860.8,201.4c-19,0-30.6-12.4-30.6-39.4c0-29,13.7-42.2,34-42.2c19,0,30.6,12.2,30.6,39.4 C894.7,188.2,881,201.4,860.8,201.4z M862.2,127.2c-13.5,0-22.2,10.5-22.2,31.4c0,25.1,7.1,35.4,22.5,35.4 c13.7,0,22.4-10.5,22.4-31.4C884.9,137.5,877.7,127.2,862.2,127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M953.3,130.6c-2.6-0.8-4.3-1-5.8-1c-5.2,0-10.5,4.2-19.5,15.1v55.5h-9.3v-79.4h7.9l1,15 c9.7-11.9,15.5-15.9,20.8-15.9c1.9,0,3.9,0.3,6,1.4L953.3,130.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M1015.6,200.2l-32.2-42.5h-0.3v42.5h-9.3V86.1h9.3v68.1h0.3l28-33.3h11.9l-31.2,34l35.1,45.4L1015.6,200.2 L1015.6,200.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M1049.7,103.2c-5.3,0-6.3-1.1-6.3-6c0-5,1-6,6.3-6s6,1,6,6C1055.7,102.1,1054.9,103.2,1049.7,103.2z  M1044.9,200.2v-79.4h9.3v79.4H1044.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M1140.8,200.2h-9.2c0-13.7,0.3-30.9,0.3-43c0-21.4-6-29.9-16.9-29.9c-6.6,0-14.3,4.3-21.7,10.6v62.3h-9.3 v-79.4h7.9l1,9.8c7.4-6.6,16.1-10.9,25.4-10.9c13.7,0,23,8.9,23,34.9C1141.3,165.8,1140.8,185.1,1140.8,200.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M1194.1,228.7c-7.4,0-16.3-1.8-23.5-4.2l1.1-5.8c8.2,1.4,15.6,2.4,21.7,2.4c13.8,0,20.4-5,20.4-20.1v-12.6 c-6.9,5.2-14.8,9.5-23.3,9.5c-14.8,0-25.8-15.5-25.8-36.7c0-29.1,18-41.5,36.9-41.5c7.6,0,15.6,1.1,21.6,2.3v76 C1223.2,222.9,1211.8,228.7,1194.1,228.7z M1213.9,129.4c-4.5-1.6-10.5-2.4-14.3-2.4c-14.3,0-24.9,11.9-24.9,31.5 c0,18.8,6.6,32,19,32c6,0,14.3-4.7,20.3-10L1213.9,129.4L1213.9,129.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M1362.5,200.2h-9.3l-17.2-57l-2.4-9.5h-0.2l-2.3,9.7l-15.1,56.8h-10.1l-24.6-79.4h10.3l16.1,53.3l3.9,14.2h0.2 l2.7-11.4l15-56h9.3l17.5,57.6l2.7,9.7h0.2c7.4-21.6,13.8-44.6,17.7-67.3h9.8C1381.8,144.2,1373.9,171.9,1362.5,200.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M1411.7,103.2c-5.3,0-6.3-1.1-6.3-6c0-5,1-6,6.3-6s6,1,6,6C1417.7,102.1,1416.9,103.2,1411.7,103.2z  M1406.9,200.2v-79.4h9.3v79.4H1406.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M1465.3,201.4c-12.9,0-17.5-6-17.5-21.6v-52H1434v-6.9h13.8c1.1-7.1,2.1-14.3,2.7-22.5h6.6v22.5h23.2v6.9 h-23.2v49.7c0,12.1,1.8,16.4,10.5,16.4c3.1,0,7.1-0.6,13.4-2.9l1.4,5.8C1476.4,199.8,1470.3,201.4,1465.3,201.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M1558.5,200.2h-9.2c0-14.6,0.3-32.4,0.3-42.7c0-21.9-6.1-30.3-17.1-30.3c-5.8,0-13.8,3.9-21.6,10.6v62.3h-9.3 v-114h9.3v44.1c6.8-5.8,15.1-10.5,24.8-10.5c13.7,0,23.2,8.9,23.2,34.9C1559,164.4,1558.5,184.2,1558.5,200.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Logo_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M1325.8,439.7c-5.7,0-11.4-0.4-17.1-1v29.5H1267V274.1h34l3.2,16.5c13.3-12,28.8-20,44.9-20 c38.8,0,57.6,34.9,57.6,78C1406.8,412.5,1372.5,439.7,1325.8,439.7 M1337.6,302.6c-7.8,0-18.4,4.5-28.8,13.6v90.6 c5.5,2.3,12.3,3.2,19.4,3.2c21,0,35.9-17.1,35.9-55.6C1364.1,321,1354.1,302.6,1337.6,302.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M777.4,443.8c-43.7,0-65.9-27.8-65.9-84.1c0-52.7,27.5-88.7,70.9-88.7c19.9,0,35.8,7.3,47.7,20.9l-14.9,21.9 c-7.4-7-17.3-10.9-27.5-10.9c-19.5,0-32.1,17.9-32.1,52.6c0,40.4,10.9,56.3,30.1,56.3c13.2,0,24.2-4.3,35.1-13.9l12.9,21.8 C820.8,432.9,802.6,443.8,777.4,443.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M911.5,444.1c-45.7,0-73.2-22.2-73.2-83.1c0-61.2,30.8-90,80.1-90c45.7,0,73.2,22.2,73.2,82.8 C991.6,415.3,960.8,444.1,911.5,444.1 M914.5,302.4c-19.6,0-32.5,13.6-32.5,51.3c0,46.7,11.6,58.9,33.5,58.9 c19.5,0,32.4-13.6,32.4-51.3C947.9,314.7,936,302.4,914.5,302.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M1240.9,440.5h-42.7c0-33.4,1-67.5,1-86.8c0-39.7-7.3-48.7-21.5-48.7c-8.6,0-20.5,6.3-31.5,14.9 c1,5.3,1.7,12.9,1.7,24.8v95.7h-42.4v-86.7c0-39.1-7.3-48.7-21.2-48.7c-7.9,0-18.9,5.3-29.8,13.6v121.8h-42.7V274.6h35.1l3,17.5 c13.2-12.2,30.1-21.2,49-21.2c20.5,0,34.1,10.2,40.4,23.8c15.9-14.2,33.1-23.8,53-23.8c32.4,0,49.7,21.2,49.7,74.8 C1242,366.3,1241,404,1240.9,440.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M1526.6,440.5l-3-16.9c-14.2,12.2-29.5,20.5-50.6,20.5c-33.4,0-51.3-16.5-51.3-47.3 c0-34.5,27.5-57.3,85.4-57.3h10.3v-12.6c0-16.9-9.6-25.2-30.8-25.2c-17.2,0-35.4,4.6-50.3,9.9l-5.6-25.8 c19.5-8.6,42.1-14.9,66.9-14.9c42.4,0,61.9,20.2,61.9,51.6v117.9H1526.6z M1517.4,365.3h-12.6c-32.4,0-41.4,10.9-41.4,26.2 c0,13.9,7.6,22.5,22.2,22.5c10.3,0,21.5-5.6,31.8-14.6L1517.4,365.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M1678.6,312.3c-4.7-1.5-9.6-2.3-14.6-2.3c-9.3,0-17.2,6.3-32.1,25.2v105.3h-42.7V274.6h35.1l3.3,25.8 c16.9-22.2,28.1-29.1,40.1-29.1c5.6,0,11.1,1.2,16.2,3.6L1678.6,312.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M1726.3,366v2.3c0,30.5,13.6,43.4,37.1,43.4c14.9,0,34.4-3,54-9.6l6,24.5c-20.2,10.6-44,17.5-68.2,17.5 c-43.7,0-72.2-21.5-72.2-82.1c0-59.3,28.5-91,75.2-91c42.4,0,70.5,23.8,66.2,95L1726.3,366z M1783.2,338.9 c0-26.5-9.3-39.4-27.2-39.4c-18.2,0-28.1,16.9-29.5,40.1h56.6V338.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M2492,440.5h-42.7c0-33.4,1-67.5,1-86.8c0-39.7-7.3-48.7-21.5-48.7c-8.6,0-20.5,6.3-31.5,14.9 c1,5.3,1.7,12.9,1.7,24.8v95.7h-42.4v-86.7c0-39.1-7.3-48.7-21.2-48.7c-8,0-18.9,5.3-29.8,13.6v121.8h-42.7V274.6h35.1l3,17.5 c13.2-12.2,30.1-21.2,49-21.2c20.5,0,34.1,10.2,40.4,23.8c15.9-14.2,33.1-23.8,53-23.8c32.4,0,49.6,21.2,49.6,74.8 C2493,366.3,2492,404,2492,440.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M2617.5,440.5l-3-16.9c-14.2,12.2-29.5,20.5-50.7,20.5c-33.4,0-51.3-16.5-51.3-47.3 c0-34.5,27.5-57.3,85.4-57.3h10.2v-12.6c0-16.9-9.6-25.2-30.8-25.2c-17.2,0-35.4,4.6-50.3,9.9l-5.6-25.8 c19.5-8.6,42.1-14.9,66.9-14.9c42.4,0,61.9,20.2,61.9,51.6v117.9H2617.5z M2608.2,365.3h-12.6c-32.4,0-41.4,10.9-41.4,26.2 c0,13.9,7.6,22.5,22.2,22.5c10.3,0,21.5-5.6,31.8-14.6V365.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M2772.8,312.3c-4.7-1.5-9.6-2.3-14.6-2.3c-9.3,0-17.2,6.3-32.1,25.2v105.3h-42.7V274.6h35.1l3.3,25.8 c16.9-22.2,28.1-29.1,40.1-29.1c5.6,0,11.1,1.2,16.2,3.6L2772.8,312.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ctm_st0",
    points: "2881.4,440.5 2837,358.4 2837,440.5 2794.3,440.5 2794.3,247 2837,247 2837,338.5 2875.1,274.6  2924.7,274.6 2875.4,343.8 2931.4,440.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M2974.4,366v2.3c0,30.5,13.6,43.4,37.1,43.4c14.9,0,34.4-3,54-9.6l6,24.5c-20.2,10.6-44,17.5-68.2,17.5 c-43.7,0-72.2-21.5-72.2-82.1c0-59.3,28.5-91,75.1-91c42.4,0,70.5,23.8,66.2,95L2974.4,366z M3031.4,338.9 c0-26.5-9.3-39.4-27.1-39.4c-18.2,0-28.1,16.9-29.5,40.1h56.6L3031.4,338.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M3144.3,443.8c-30.8,0-42.1-11.6-42.1-43.4v-96H3081v-29.8h22.5c4-9,7.4-18.2,10.3-27.6h30.8v27.6h36.8v29.8 h-36.8v85.4c0,16.9,4,22.2,15.2,22.2c5,0,11.9-0.7,22.5-3.6l3.3,24.5C3170.1,440.8,3156.9,443.8,3144.3,443.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M1901.3,442.8c-27.6,0-37.4-11.8-37.4-43.6V296.4h-26.2v-19h26.6c2.6-14.4,4.9-13.2,6.9-30.2h18.7v30.2h43.6 v19h-43.6v96.2c0,22.3,3.6,30.2,19.3,30.2c5.6,0,13.1-1,25.3-5.2l3.3,15.8C1924.6,439.5,1912.1,442.8,1901.3,442.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M2084.1,440.1h-25.6c0-30.9,0.6-66.6,0.6-86.6c0-43-11.2-57.8-31.2-57.8c-10.8,0-25.6,6.9-40,19.4v125H1962 v-193h25.9v48c13.5-11.1,29.5-20.4,48.9-20.4c29.5,0,48.2,18.7,48.2,72.2C2085.1,366.6,2084.1,406.4,2084.1,440.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M2134.6,362v3.3c0,40.7,15.8,57.1,44.9,57.1c16.4-0.1,32.5-3.5,47.6-9.8l4.9,15.4 c-18.1,9.5-38.3,14.6-58.8,14.8c-39.4,0-65.6-21.3-65.6-79.1c0-56.8,24.6-89,66.6-89c38.4,0,61.7,24.6,58.1,87.3H2134.6z  M2207.1,343.3c0-31.2-11.1-49.9-34.5-49.9c-24,0-36.4,23.3-38.1,51.2h72.5V343.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ctm_st0",
    points: "3215.1,279.1 3215.1,319.5 3209.6,319.5 3209.6,279.1 3198,279.1 3198,274.8 3226.8,274.8  3226.8,279.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "ctm_st0",
    d: "M3272.2,319.5c-0.3-13.8-1.3-28.7-2.5-37.7h-0.1l-12.6,37.7h-4.2l-12.7-37.7h-0.1c-0.9,9.9-1.5,23.9-1.7,37.7 h-5.4c0.3-14.9,1.5-29.9,3.3-44.7h7.1l12.1,35.4l0,0l12.1-35.4h6.9c1.8,14.4,3.1,30.4,3.5,44.7H3272.2z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CTM_SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.8274,
    y1: 116.1404,
    x2: 509.6354,
    y2: 591.663
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0007411859,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03344613,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08879401,
    style: {
      stopColor: "#ECEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1474,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6439,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7257,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7949,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8822,
    style: {
      stopColor: "#DADADA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    style: {
      stopColor: "#C1C1C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BABABA"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "ctm_st1",
    cx: 355.2,
    cy: 353.9,
    r: 283.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CTM_SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.6871,
    y1: 555.5068,
    x2: 607.828,
    y2: 614.7422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1005,
    style: {
      stopColor: "#641724"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2125,
    style: {
      stopColor: "#711825"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4195,
    style: {
      stopColor: "#931B26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5839,
    style: {
      stopColor: "#B31E28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2202F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ctm_st2",
    d: "M232.8,496.5c-1,34.1-8.3,67.8-21.2,101.8c42.2,24.8,91.1,39,143.6,39c39.8,0,77.7-8.2,112.1-23 C411.6,555.6,329.4,508.4,232.8,496.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CTM_SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.1847,
    y1: 662.5453,
    x2: 615.3551,
    y2: 662.5453,
    gradientTransform: "matrix(0.9892 0.1464 -0.1464 0.9892 62.7388 -145.3481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07921875,
    style: {
      stopColor: "#321724"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#381724",
      stopOpacity: 0.8776
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    style: {
      stopColor: "#4B1826",
      stopOpacity: 0.7068
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5326,
    style: {
      stopColor: "#681A28",
      stopOpacity: 0.5076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7359,
    style: {
      stopColor: "#921D2B",
      stopOpacity: 0.2868
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    style: {
      stopColor: "#C6202E",
      stopOpacity: 0.05105895
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2202F",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ctm_st3",
    d: "M232.8,496.4c-0.5,17.7-2.7,35.3-6.5,52.8c0,0,0,0,0,0c74.1,5.3,140.3,34.9,192.1,81c16.9-3.9,33.3-9.2,48.9-16 C411.6,555.7,329.4,508.4,232.8,496.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CTM_SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.733,
    y1: 898.2553,
    x2: 338.733,
    y2: 689.3545,
    gradientTransform: "matrix(0.9892 0.1464 -0.1464 0.9892 62.7388 -145.3481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#95191D",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4A191D"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ctm_st4",
    d: "M232.1,609.3c36,17.4,76.2,27.4,118.7,28C324.4,587.5,277.9,566.2,232.1,609.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CTM_SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.567,
    y1: 540.4374,
    x2: 537.4684,
    y2: 540.4374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B59F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8681,
    style: {
      stopColor: "#F0EEC5"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ctm_st5",
    d: "M418.7,468.5c-27.1-5.1-53.5,0.7-72.1,10.6c0.1,0,0.1,0.1,0.2,0.1c37.9,17.1,26,36,38.3,69.6 c31.4,18.7,59.1,41.1,82.2,65.5c16.8-7.2,32.7-16,47.6-26.2c0-0.1-0.1-0.2-0.1-0.2C488.3,505.2,453,475,418.7,468.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CTM_SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.3444,
    y1: 527.2789,
    x2: 377.939,
    y2: 469.2648
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B59F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8681,
    style: {
      stopColor: "#F0EEC5"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ctm_st6",
    d: "M346.8,479.2c-0.1,0-0.1-0.1-0.2-0.1c-52.3-22.3-116.5-24.6-116.4-23.9c2.2,15.6,3.1,26,2.7,41.3h0c0,0,0,0,0,0 c50.7,6.2,97.4,22.2,138.4,44.5c4.7,2.6,9.3,5.2,13.9,7.9C372.8,515.2,384.7,496.3,346.8,479.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CTM_SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.6185,
    y1: 426.946,
    x2: 525.0905,
    y2: 185.453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25130E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01692745,
    style: {
      stopColor: "#2A1711"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    style: {
      stopColor: "#AC8864"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#E0B585"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8032,
    style: {
      stopColor: "#E9C08F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#FBD6A4"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ctm_st7",
    d: "M496,200.5c0,0-22.9,2.5-33.4,2.8c-17.5,0.6-32.5,1.5-36.5,0.4c0,0,0,0,0,0c-25.4-4.4-47-30.2-53.3-43.1 c0-0.1-0.1-0.2-0.1-0.3c-1-1.8-2.2-2.2-4-1.7c-2.5,0.7-6.4,3.1-13.3,6c-0.2,0.1-0.4,0.2-0.6,0.2c0,0,0,0-0.1,0 c-4.4,1.8-9.9,3.8-16.9,5.7c-26.7,7.3-53.9,8.4-91.3,27.1c-36.8,18.4-64.7,45.8-77.5,78.4c-24.9,63,3.6,108.5,37.4,138 c12.2,10.7,20.5,25.1,23.8,41l0,0c-0.1-0.7,64.1,1.6,116.4,23.9c18.3-9.8,44.3-15.6,70.9-10.8c0,0,0,0,0,0c-14-27.1-1.5-45,2.6-51.7 c4.8-8.1,6.5-9.9,13.1-16.6c-1.8-0.6-5.3-0.9-6.1-3.5c0,0,16.6-14.8,26.8-31.6c0.1-0.2,0.2-0.4,0.3-0.6 c9.5-20.2,16.7-36.6,16.7-36.6c26.4-24.5,43.3-44,49.2-61.4C547.3,258.6,552.4,192.6,496,200.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CTM_SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 417.4102,
    y1: 312.3809,
    x2: 133.3676,
    y2: 453.2386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00136218,
    style: {
      stopColor: "#E0B585",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1042,
    style: {
      stopColor: "#B38F68",
      stopOpacity: 0.1258
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#89694D",
      stopOpacity: 0.2671
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    style: {
      stopColor: "#654B36",
      stopOpacity: 0.4109
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4548,
    style: {
      stopColor: "#493325",
      stopOpacity: 0.5551
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5733,
    style: {
      stopColor: "#362218",
      stopOpacity: 0.7001
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6928,
    style: {
      stopColor: "#2A1710",
      stopOpacity: 0.8464
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    style: {
      stopColor: "#26140E",
      stopOpacity: 0.996
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#25130E"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "ctm_st8",
    d: "M454.6,363.4c0,0.1,0,0.1,0,0.2c-9.6,16.6-26,31.5-27.4,32.7c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1 c0.9,2.6,4.3,2.9,6.1,3.5c-6.6,6.8-8.3,8.5-13.1,16.6c-4,6.8-16.6,24.5-2.6,51.6l0,0c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0 c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0-0.5-0.1-0.8-0.1c-0.3,0-0.5-0.1-0.8-0.1l0,0c-0.6-0.1-1.1-0.2-1.7-0.2c0,0,0,0,0,0 c-0.4-0.1-0.8-0.1-1.2-0.2c-0.7-0.1-1.4-0.2-2.1-0.2c-0.1,0-0.2,0-0.3,0c-0.5-0.1-1-0.1-1.5-0.2c-1.2-0.1-2.3-0.2-3.5-0.3 c-8.9-0.6-17.5-0.1-25.6,1.3c0,0-0.1,0-0.1,0c-1.5,0.2-3,0.5-4.4,0.8c-4.5,0.9-8.8,2.1-12.9,3.5c0,0,0,0,0,0 c-2.1,0.7-4.2,1.5-6.1,2.4c-1.1,0.4-2.1,0.9-3.2,1.4l0,0l0,0c-1,0.5-2,0.9-3,1.4c-0.1,0-0.1,0.1-0.2,0.1c-1,0.5-1.9,0.9-2.8,1.4 c-1.3-0.5-2.6-1.1-3.9-1.6c-0.2-0.1-0.4-0.2-0.6-0.3c0,0,0,0,0,0c-1.2-0.5-2.4-1-3.6-1.4c0,0,0,0,0,0c-0.3-0.1-0.6-0.2-0.9-0.4l0,0 c-1-0.4-2-0.8-3.1-1.2c-0.5-0.1-0.9-0.3-1.4-0.5c0,0,0,0,0,0c-1.2-0.4-2.4-0.8-3.6-1.2c0,0,0,0,0,0c0,0,0,0,0,0 c-1.4-0.5-2.8-0.9-4.3-1.4c0,0,0,0,0,0c-0.3-0.1-0.6-0.2-0.8-0.3l0,0c-2.8-0.9-5.6-1.7-8.3-2.5l0,0c-0.3-0.1-0.6-0.2-0.8-0.2 c0,0,0,0,0,0c-1.2-0.3-2.5-0.7-3.7-1c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.3-0.1-0.4-0.1c0,0,0,0,0,0c0,0,0,0,0,0 c-1.2-0.3-2.4-0.6-3.7-0.9l0,0c0,0-0.1,0-0.1,0c-1.4-0.4-2.9-0.7-4.3-1.1c0,0,0,0,0,0c-0.3-0.1-0.5-0.1-0.8-0.2 c-1.3-0.3-2.5-0.6-3.8-0.9c0,0,0,0,0,0c-0.1,0-0.2,0-0.3-0.1c-1.4-0.3-2.8-0.6-4.2-0.9c-0.1,0-0.2,0-0.3-0.1c0,0,0,0,0,0 c-4.1-0.9-8.1-1.6-12.1-2.3l0,0c-0.2,0-0.4-0.1-0.6-0.1c0,0,0,0,0,0c-1.2-0.2-2.4-0.4-3.6-0.6c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0 c0,0,0,0,0,0c-1.1-0.2-2.2-0.4-3.3-0.5c-0.1,0-0.2,0-0.2,0c0,0-0.1,0-0.1,0c-0.9-0.1-1.7-0.3-2.6-0.4l0,0c0,0-0.1,0-0.1,0 c-0.8-0.1-1.6-0.2-2.4-0.3c0,0,0,0,0,0c-0.2,0-0.4-0.1-0.7-0.1c0,0,0,0,0,0c-0.6-0.1-1.2-0.2-1.8-0.3c0,0,0,0,0,0 c-0.2,0-0.4-0.1-0.7-0.1c0,0,0,0,0,0c-0.8-0.1-1.5-0.2-2.3-0.3c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.8-0.1-1.5-0.2-2.3-0.3c0,0,0,0,0,0 c-0.1,0-0.2,0-0.2,0c-0.7-0.1-1.4-0.2-2-0.2h0c-0.1,0-0.2,0-0.4,0c-1.6-0.2-3.1-0.4-4.6-0.5c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0 c0,0,0,0,0,0c-1-0.1-1.9-0.2-2.8-0.3c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.4,0-0.7-0.1-1.1-0.1c0,0,0,0,0,0c-0.2,0-0.4,0-0.5-0.1 c0,0,0,0,0,0c-0.5,0-1-0.1-1.4-0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.4,0-0.7-0.1-1-0.1c0,0,0,0-0.1,0c-0.1,0-0.3,0-0.4,0c0,0,0,0,0,0 c-0.9-0.1-1.7-0.1-2.5-0.2c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.9-0.1-1.8-0.1-2.6-0.2c0,0,0,0,0,0c0,0,0,0,0,0c-0.4,0-0.7,0-1.1-0.1 c0,0,0,0-0.1,0c0,0,0,0-0.1,0c-0.3,0-0.6,0-0.9-0.1c-0.4,0-0.7,0-1-0.1c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0 c-0.2,0-0.5,0-0.7,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.2,0-0.5,0-0.7,0c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.4,0c0,0,0,0,0,0c-0.2,0-0.3,0-0.4,0 c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0c-0.2,0-0.4,0-0.6,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.3,0-0.5,0-0.8,0 c-0.2,0-0.3,0-0.5,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.2,0-0.3,0-0.5,0h0c0,0,0,0,0,0c-0.2,0-0.3,0-0.4,0c0,0,0,0,0,0c0,0,0,0,0,0 c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0,0,0l0,0c-0.2-0.7-0.4-1.5-0.6-2.2 c-0.3-1-0.6-2.1-0.9-3.1c0,0,0,0,0,0c-0.6-2-1.3-3.9-2-5.8l0,0c0-0.1-0.1-0.2-0.1-0.3v0c-1.1-2.9-2.4-5.7-3.9-8.4l-0.6-1l-0.5-0.9 c-0.5-0.9-0.6-1.1-1.1-1.9v0l0,0c-0.9-1.4-1.7-2.8-2.7-4.1c0,0,0,0,0,0c0,0,0,0,0,0l0,0c-0.5-0.8-1.1-1.5-1.7-2.3l-0.2-0.3 c-1.4-2-3-3.8-4.6-5.6h0c0,0,0,0,0,0c-0.9-1-1.8-1.9-2.7-2.8c0,0,0,0,0,0c-1.2-1.2-2.4-2.3-3.6-3.4c0,0,0,0,0,0c0,0,0,0,0,0 c-1.3-1.2-2.6-2.3-3.9-3.6c0,0,0,0,0,0c-0.1-0.1-0.2-0.1-0.2-0.2c-1.3-1.2-2.5-2.4-3.8-3.7c0,0,0,0-0.1-0.1c0,0,0,0-0.1-0.1 c0,0,0,0,0,0c-1.3-1.3-2.5-2.6-3.7-3.9c0,0,0,0,0,0c-1.2-1.3-2.5-2.7-3.7-4.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c-0.9-1.1-1.8-2.1-2.7-3.2c0,0,0,0,0,0c-13.6-16.6-23.9-36.6-26.4-60.2c-1.6-15.1,0-31.7,6-49.7c0,0,0,0,0-0.1c0,0,0,0,0,0 c0.4-1.1,0.8-2.2,1.1-3.3c0,0,0-0.1,0-0.1c-9.3,93.5,49.6,110.3,109.4,104.4c-3.8,3.7-8,7.2-12.3,10.4c-0.4,0.3-0.5,1.1,0.2,1.2 c16.7,2.9,32.3-4.3,47.2-10.8c-3,4.4-6.6,8.1-10.4,11.9c-0.4,0.4-0.1,1.1,0.5,1.1c21.7-0.3,40.3-13.9,57-26.4 c-0.8,2.5-1.7,5.1-2.5,7.6c-0.2,0.5,0.3,1,0.8,0.8c15.3-5,28-15,37.9-27.4v0c9.5-13.6,28.7-16.1,41.3-5.3L454.6,363.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CTM_SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.9615,
    y1: 281.999,
    x2: 286.4283,
    y2: 296.5224
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06959134,
    style: {
      stopColor: "#25130E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3321,
    style: {
      stopColor: "#351C13",
      stopOpacity: 0.7824
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7937,
    style: {
      stopColor: "#5A321E",
      stopOpacity: 0.4
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "ctm_st9",
    d: "M240.2,308.5c-5.1-6.8-8.7-15.9-7.5-24.5c-2.8,1.5-5.5,3.2-8.4,4.7c-0.4,0.2-1,0-1-0.6c0.6-8.4,4.9-15.3,7.6-23 c-3.7,0.6-7.4,1.4-11,2.5c-0.5,0.1-1.1-0.5-0.7-1c8.8-13.4,23.9-22.3,38.9-27.5c0.1-0.3,0.2-0.5,0.4-0.8c1-2.1,1.3-3.7,1-5l0-0.2 c-4.2-16.6-38.9-2.5-55.1,16.8c-15.4,18.2-19.4,42.5-14.7,62.9c4.8,21.1,18.8,38,39.1,39.7c4.5,0.4,9,0.1,13.4-0.8l0.5-0.1 c3.2-0.8,6.3-1.9,9.3-3.5c9.1-4.7,15.2-16.1,11.7-27.6C255,317.4,246.1,316.4,240.2,308.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CTM_SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.9156,
    y1: 266.0885,
    x2: 537.5706,
    y2: 222.8961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2093,
    style: {
      stopColor: "#E0B585",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2255,
    style: {
      stopColor: "#DDB283",
      stopOpacity: 0.2164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4658,
    style: {
      stopColor: "#AC8461",
      stopOpacity: 0.4589
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    style: {
      stopColor: "#886249",
      stopOpacity: 0.672
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8486,
    style: {
      stopColor: "#724E3A",
      stopOpacity: 0.8454
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9596,
    style: {
      stopColor: "#6A4634",
      stopOpacity: 0.9575
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "ctm_st10",
    d: "M539.8,232.2c0-1-0.1-2.1-0.2-3.1c-0.1-1-0.2-1.9-0.4-2.9c-0.1-0.6-0.2-1.2-0.4-1.7c-0.6-2.5-1.4-5-2.5-7.3 c-0.7-1.4-1.4-2.7-2.3-4c-0.5-0.8-1.1-1.5-1.7-2.2c-0.4-0.5-0.8-0.9-1.2-1.4c-1.1-1.1-2.3-2.2-3.6-3.2c-0.9-0.6-1.8-1.3-2.8-1.8 c-6.9-4-16.3-5.8-28.6-4c0,0-22.8,2.5-33.3,2.8c0,0,0,0,0,0c-14.2,0.5-26.5,1.2-33,0.8c-1.5-0.1-2.7-0.2-3.5-0.4 C459.6,214.3,405,299.2,490,309c10.6-11.1,18.8-21,24.2-30.3c0,0,0.1-0.1,0.1-0.1c0.5-0.8,0.9-1.6,1.4-2.5c0,0,0,0,0-0.1 c0.4-0.7,0.8-1.5,1.1-2.2c0.1-0.1,0.1-0.3,0.2-0.4c0.4-0.8,0.7-1.5,1.1-2.3c0,0,0-0.1,0.1-0.1c0.3-0.7,0.6-1.4,0.9-2 c0.1-0.2,0.1-0.4,0.2-0.5c0.3-0.7,0.5-1.4,0.8-2.1h0v0c0.3-0.1,0.6-0.2,0.9-0.3c0.3-0.1,0.6-0.2,0.9-0.3c0.8-0.3,1.7-0.7,2.5-1.1 c0.5-0.3,0.9-0.5,1.3-0.8c0.2-0.2,0.5-0.3,0.7-0.5c1-0.7,1.9-1.4,2.7-2.2c0,0,0.1-0.1,0.1-0.1c4-3.8,7-9,8.8-14.9 C539.3,241.6,539.9,236.9,539.8,232.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CTM_SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.1961,
    y1: 211.3548,
    x2: 431.3057,
    y2: 211.3548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5A321E",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2039,
    style: {
      stopColor: "#4D2A19",
      stopOpacity: 0.3356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4877,
    style: {
      stopColor: "#412315",
      stopOpacity: 0.6635
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7789,
    style: {
      stopColor: "#3D2114"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "ctm_st11",
    d: "M309.9,207.9c2.2,0,4.5-0.1,6.7-0.5c0.6-0.1,1,0.4,0.7,1c-5.9,12.3-11,24-8.8,37.9c0.8,5.3,2.6,11.1,5.5,16.1 c0.5,0.8,1.2,1.5,2.1,1.8c0,0,0,0,0,0c10.5-45.1,94.4-17.4,110.1-60.5c-25.4-4.4-47-30.2-53.3-43.1c0-0.1-0.1-0.2-0.1-0.3 c-1-1.8-2.2-2.2-4-1.7c-2.5,0.7-6.4,3.1-13.3,6c-0.2,0.1-0.4,0.2-0.6,0.2c0,0,0,0-0.1,0c-1.6,0.7-3.3,1.3-5.2,2 C332.7,175.3,318.5,191.2,309.9,207.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CTM_SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.076,
    y1: 219.3961,
    x2: 399.3937,
    y2: 219.3961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00136218,
    style: {
      stopColor: "#5A321E",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3025,
    style: {
      stopColor: "#452618",
      stopOpacity: 0.281
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    style: {
      stopColor: "#2E1810",
      stopOpacity: 0.5396
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#25130E",
      stopOpacity: 0.7
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "ctm_st12",
    d: "M375.1,200.1c-15.8,1.8-22.5,32.3-32,38.8h0c17-5.5,38.8-6.4,56.1-12.1C401.4,206.5,388.9,198.5,375.1,200.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CTM_SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.077,
    y1: 224.7626,
    x2: 391.9674,
    y2: 224.7626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25130E",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#25130E"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "ctm_st13",
    d: "M379.7,215.1c-8.2,0.5-12.6,15.5-17.6,19.3c9.9-1.8,20.3-3.2,29.8-5.6c0,0,0,0,0,0 C393,218.9,386.8,214.7,379.7,215.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "CTM_SVGID_14_",
    cx: 512.9541,
    cy: 240.4312,
    r: 151.232,
    gradientTransform: "matrix(0.9816 -0.191 0.1382 0.7102 -23.7822 167.6488)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3851,
    style: {
      stopColor: "#47210E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5308,
    style: {
      stopColor: "#4A2410",
      stopOpacity: 0.763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6298,
    style: {
      stopColor: "#532C17",
      stopOpacity: 0.602
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7149,
    style: {
      stopColor: "#623B23",
      stopOpacity: 0.4636
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7922,
    style: {
      stopColor: "#785034",
      stopOpacity: 0.3379
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8642,
    style: {
      stopColor: "#936B49",
      stopOpacity: 0.2208
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9321,
    style: {
      stopColor: "#B68C64",
      stopOpacity: 0.1105
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#DDB383",
      stopOpacity: 0.006687403
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E0B585",
      stopOpacity: 0
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "ctm_st14",
    d: "M445.9,359.6c4.8,2.1,10.5,0,12.7-4.8c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.2c0.3-0.6,0.6-1.3,0.9-1.9 c0,0,0-0.1,0.1-0.1c0.9-2,1.8-4,2.7-5.8c0,0,0,0,0,0c5-11.3,8.5-19,8.5-19l0,0c26.4-24.5,43.3-43.9,49.1-61.4c0,0,0,0,0,0l0,0 c-57,36-110.1-1.2-141.9,21.8c-0.7,0.6-2.3,2.1-4.4,4.2c-12.1,11.7-8.4,31.9,6.9,38.7L445.9,359.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CTM_SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 498.2872,
    y1: 232.2159,
    x2: 542.1409,
    y2: 207.814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1397,
    style: {
      stopColor: "#5A321E",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2342,
    style: {
      stopColor: "#532E1C",
      stopOpacity: 0.3659
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7296,
    style: {
      stopColor: "#311A12",
      stopOpacity: 0.7114
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#25130E",
      stopOpacity: 0.9
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "ctm_st15",
    d: "M497.4,200.3l-0.2,0.3c-1,1.9-1.6,3.6-1.9,5.2c0,0,0.1,0,0.1,0.1c1.6,1.4,3.3,2.4,5.3,3.1 c2.3,0.8,3.2,2,4.5,4.1c0.9,1.5,1.3,3.1,1.9,4.7c0.3,0.7,0.6,1.3,0.9,1.9c13.7,4.5,33,6.7,30.8,22.2 C543.1,221.3,532.7,196.1,497.4,200.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPe26Ys778488);
export default __webpack_public_path__ + "static/media/PE26YS778488.125818a1db008ec3ef01ac3b65712f54.svg";
export { ForwardRef as ReactComponent };